import { useState } from "react"
import { useNavigate } from "react-router-dom"
import { Stack, Box, Typography } from "@mui/material"
import { styles } from "../config/config.flow"

export default function Roadmap(props) {
    // console.log("Roadmap: Rendering with props", props)
    const { roadmap, roadmapIndex } = props
    const navigate = useNavigate()
    
    // State for mobile collapse/expand
    const [displayRoadmap, setDisplayRoadmap] = useState(false)
    
    // Find which menu item is currently active (has steps)
    const currentMenuStep = roadmap.findIndex(obj => obj.steps?.length > 0)
    // console.log("Roadmap: Current menu step index:", currentMenuStep)
    
    return (
        <Stack sx={styles.roadmapContainer}>
            {/* Mobile header - collapsible */}
            <Stack 
                onClick={() => setDisplayRoadmap(!displayRoadmap)} 
                sx={styles.mobileRoadmapContainer}
            >
                <Stack flexDirection="row" gap="10px">
                    <img src="/assets/images/onboarding/roadmap-flag.svg" alt="flag" />
                    <Typography sx={styles.mobileRoadmapHeader}>Roadmap</Typography>
                </Stack>
                <Box
                    component="img"
                    src="/assets/images/onboarding/roadmap-wrapper.svg"
                    alt="arrow"
                    sx={styles.mobileRoadmapArrow(displayRoadmap)}
                />
            </Stack>
            
            {/* Roadmap menu items */}
            <Stack sx={styles.roadmap(displayRoadmap)}>
                {roadmap.map((item, index) => {
                    const { label, disabled, steps, url } = item
                    const isCurrentMenu = index === currentMenuStep
                    const isLastItem = index === roadmap.length - 1
                    
                    return (
                        <Stack 
                            key={index} 
                            sx={{
                                ...styles.formContainer,
                                marginBottom: isLastItem ? 0 : "20px"
                            }}
                        >
                            {/* Menu item label */}
                            <Typography
                                onClick={!disabled && url ? () => navigate(url) : undefined}
                                sx={styles.formLabel(isCurrentMenu, disabled)}
                            >
                                {label}
                            </Typography>
                            
                            {/* Steps (sub-items) - show if steps exist */}
                            {steps && steps.length > 0 && (
                                <Stack sx={styles.stepsContainer(true)}>
                                    {steps.map((step, stepIndex) => {
                                        const { 
                                            label: stepLabel, 
                                            disabled: stepDisabled,
                                            url: stepUrl,
                                            // hide, 
                                            subMenu 
                                        } = step
                                        
                                        // if (hide) return null
                                        
                                        const isCurrentStep = isCurrentMenu && stepIndex === roadmapIndex
										// console.log(`Roadmap: Rendering step ${stepIndex} ${stepLabel}- subMenu = ${subMenu}isCurrentStep: ${isCurrentStep}, stepDisabled: ${stepDisabled}, stepUrl: ${stepUrl}`)
                                        
                                        return (
                                            <Stack
                                                key={stepIndex}
                                                flexDirection="row"
                                                alignItems="center"
                                                gap="6px"
                                                sx={{
                                                    ...styles.step(isCurrentStep, stepDisabled, subMenu),
                                                    // Apply additional indentation for subMenu items
                                                    paddingLeft: subMenu 
                                                        ? '24px' 
                                                        : '0px'
                                                }}
                                                onClick={!stepDisabled && !isCurrentStep && stepUrl ? () => navigate(stepUrl) : undefined}
                                            >
                                                {isCurrentStep && (
                                                    <Box
                                                        component="img"
                                                        src="/assets/images/onboarding/arrow-right.svg"
                                                        alt="arrow"
                                                        sx={{
                                                            width: '14px',
                                                            height: '12px',
                                                            opacity: 0.6,
                                                        }}
                                                    />
                                                )}
                                                {stepLabel}
                                            </Stack>
                                        )
                                    })}
                                </Stack>
                            )}
                        </Stack>
                    )
                })}
            </Stack>
        </Stack>
    )
}
